<template>
    
   <ModalLibroMayorDetalle :listDetalle="listDetalle" :totalGastos="totalGastos" :visible="showModalGasto"   @update:visible="showModalGasto  = $event" />
 
   <ModalDetalleEjecucionPresupuestaria 
   :borrador="borrador"
    :visible="visibleModal"
     @update:visible="visibleModal = $event"
    :centro_responsable_cuentas="solo_centro_responsable_cuentas" :selectedCategoria="selectedCategoria"
    :selectedCuenta="selectedCuenta" />
 
<table class=" text-sm text-gray-700 font-mono w-[1200px]  ">
          <!-- THEAD -->
          <thead class="bg-gray-100 text-gray-600  text-xs tracking-wide">
            <tr>
              <th cols="5">
                <div class="flex justify-between">
                  <span
                    class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">&lt;ReporteriaTablaTotales&gt;</span>
                  <span
                    class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">/api/v1/presupuesto/todoscentros/</span>
                </div>
              </th>
            </tr>
          
          
            <tr class="uppercase">
              <th class="text-left px-6 py-3">Categoría {{ tipo_categoria }}</th>
              <th class="text-center px-6 py-3  text-right">Presupuesto {{ año }} </th>
              <th class="text-center px-6 py-3  text-right">Gastos</th>
              <th class="px-6 py-3   ">% Ejecución {{ año }}</th>
            </tr>
          </thead>

          <!-- TBODY -->
          <tbody>
            <tr v-for="(item, index) in array_presupuesto_categorias" :key="index"
              class="border-b hover:bg-gray-50 transition" :class="{ 'bg-gray-50': index % 2 !== 0 }">
              <!-- Nombre -->
              <td class="px-6 py-3   text-center font-mono text-gray-800">
                {{ item.nombre }}
              </td>

              <!-- Presupuesto -->
              <td class="px-6 py-3   font-mono  text-right ">
                $ {{ $formatoMiles(item.total_presupuesto) }}
                
                <span @click="openModalDet(item.id,  getCategoriaActual(item.id)?.nombre || item.nombre
                )" class="cursor-pointer">[+]</span>
              </td>
              <!-- Presupuesto -->
              <td class="px-6 py-3    font-mono text-right">
                $ {{ $formatoMiles(item.total_gastos) }}
              </td>
              <!-- Porcentaje -->
              <td class="px-6 py-3 font-mono  ">
                <div class="flex items-center gap-3">

                  <!-- Barra -->
                  <div class="w-full bg-gray-200 rounded h-2 overflow-hidden">
                    <div class="h-2 transition-all duration-300" :class="{
                      'bg-blue-500': item.total_gastos / item.total_presupuesto < 0.5,
                      'bg-yellow-500': item.total_gastos / item.total_presupuesto >= 0.5 && item.total_gastos / item.total_presupuesto < 0.8,
                      'bg-red-500': item.total_gastos / item.total_presupuesto >= 0.8
                    }" :style="{
                      width: item.total_presupuesto > 0
                        ? Math.min((item.total_gastos / item.total_presupuesto) * 100, 100) + '%'
                        : '0%'
                    }"></div>
                  </div>

                  <!-- Texto porcentaje -->
                  <span class="w-14 text-right">
                    {{
                      item.total_presupuesto > 0
                        ? ((item.total_gastos / item.total_presupuesto) * 100).toFixed(1)
                        : 0
                    }}%
                  </span>

                </div>
              </td>

            </tr>
          </tbody>

          <!-- TFOOT -->
          <tfoot class="bg-gray-100">
            <tr>
              <td class="px-6 py-3 font-semibold text-gray-800  text-xs  font-mono ">
                TOTAL GENERAL
              </td>
              <td class="px-6 py-3  font-semibold font-mono text-right">
                $ {{ $formatoMiles(tot_tabla1.presupuestos) }}
              </td>
              <td class="px-6 py-3  font-semibold font-mono text-gray-700  text-right">
                $ {{ $formatoMiles(tot_tabla1.gastos) }}
              </td>
              <td class="px-6 py-3   font-semibold font-mono text-gray-700">
            
              
                    {{ tot_tabla1.presupuestos === 0
                        ? '0.0%'
                        : ((tot_tabla1.gastos / tot_tabla1.presupuestos) * 100).toFixed(1) + '%'
                    }}
              </td>
            </tr>
          </tfoot>

        </table>

 <!-- MODAL -->
  <div v-if="showModalDet" class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 ">
    
    <div class=" w-full max-w-7xl  p-6">
 
      <div class="w-full   mx-auto p-6">

        <div class="flex justify-between">

        <span class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">&lt;ReporteriaTablaTotales&gt;</span>
        <span class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">/api/v1/presupuesto/todoscentros/</span>
        
        </div>

        <div class=" overflow-hidden  ">


          <div class="w-full  mx-auto p-6">
            <div class="bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-100 h-[80vh] flex flex-col">

              <!-- Header (fijo) -->
              <div class="px-6 py-5 bg-gradient-to-r from-purple-600 via-pink-500 to-indigo-600 flex-shrink-0">
                <div class="flex items-center justify-between">
                  <div class="flex items-center gap-3">
                    <div class="p-2 bg-white/20 rounded-lg">
                      <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                      </svg>
                    </div>
                    <div>
                      
                      <p class="text-lg font-semibold text-white">{{ titulo_modal }}</p>
                    </div>
                  </div>
                  <div class="flex items-center gap-3">
                    <span class="px-3 py-1 bg-white/20 rounded-full text-sm text-white">
                      {{ det.centros.length }} centros
                    </span>
                    <span class="px-3 py-1 bg-white/20 rounded-full text-sm text-white">
                      {{ centrosConPresupuesto }} activos
                    </span>
                  </div>
                </div>
              </div>

              <!-- Tabla con div (scrollable) -->
              <div class="flex-1 min-h-0 overflow-hidden ">
                <div class="h-full  overflow-y-auto overflow-x-auto">

                  <!-- Header -->
                  <div
                    class="sticky top-0 z-10 bg-gray-50/80 border-b border-gray-200 grid grid-cols-12 gap-2 px-6 py-3">
                    <div class="col-span-1 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">
                      #
                    </div>
                   
                     <div class="col-span-1 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">
                     Territorio  
                    </div>
                     <div class="col-span-2 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">
                       Centro
                    </div>
                    <div class="col-span-2 text-right text-xs font-semibold text-gray-500 uppercase tracking-wider">
                      Total Presupuestos
                    </div>
                    <div class="col-span-2 text-right text-xs font-semibold text-gray-500 uppercase tracking-wider">
                      Total Gastos
                    </div>
                      <div class="col-span-2 text-right text-xs font-semibold text-gray-500 uppercase tracking-wider">
                      Saldo disponible
                    </div>
                    <div class="col-span-2 text-center text-xs font-semibold text-gray-500 uppercase tracking-wider">
                      Estado
                    </div>
                  </div>

                 <!-- Body -->
                  <div class="divide-y divide-gray-100">
                    <div v-for="(centro, index) in det.centros" :key="centro.centro_id"
                      class="grid grid-cols-12 gap-2 px-6 py-3 hover:bg-purple-50/50 transition-colors duration-150 group items-center">
                      <div class="col-span-1 text-sm text-gray-400  ">
                        {{ String(index + 1).padStart(2, '0') }}
                      </div>
                      <div class="col-span-1">
                        <div class="grid grid-cols-2 gap-3 text-sm   text-gray-700">

                          {{ nombreClasificacionCentro(centro.clasificacioncentro_id) }}

                        </div>
                      </div>
                      <div class="col-span-2">
                        <span class="text-right  text-sm  ">
                          <b>{{ centro.nombre }}</b>
                        </span>
                      </div>
                      <div class="col-span-2 text-right">
                        <span class="text-sm font-mono font-semibold"
                          :class="parseFloat(centro.total_presupuestos) > 0 ? 'text-gray-800' : 'text-gray-400'">
                          $ {{ $formatoMiles(centro.total_presupuestos) }}
                        </span>
                      </div>
                      <div class="col-span-2 text-right">
                        <span class="text-sm font-mono font-semibold"
                          :class="parseFloat(centro.total_gastos) > 0 ? 'text-gray-800' : 'text-gray-400'">
                          $ {{ $formatoMiles(centro.total_gastos) }}
                        </span>
                      </div>
                      <div class="col-span-2 text-right">
                        <span class="text-sm font-mono font-semibold"
                          :class="parseFloat(centro.total_saldo) > 0 ? 'text-gray-800' : 'text-red-400'">
                          $ {{ $formatoMiles(centro.total_saldo) }}
                        </span>
                        <span @click="detalle(centro.centro_id, centro.nombre)" style="cursor:pointer"> [+]</span>
                      </div>
                      <div class="col-span-2 text-center">
                        <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium" :class="parseFloat(centro.total_presupuestos) > 0
                          ? 'bg-green-100 text-green-800'
                          : 'bg-gray-100 text-gray-500'">
                          <span class="w-1.5 h-1.5 rounded-full mr-1.5"
                            :class="parseFloat(centro.total_presupuestos) > 0 ? 'bg-green-500' : 'bg-gray-400'">
                          </span>
                          {{ parseFloat(centro.total_presupuestos) > 0 ? 'Activo' : 'Sin presupuesto' }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- Total (sticky bottom) -->
                  <div
                    class="sticky bottom-0 z-10 bg-gradient-to-r from-purple-50/80 to-indigo-50/80 border-t-2 border-purple-200 grid grid-cols-12 gap-2 px-6 py-4">
                    <div class="col-span-3 text-right">
                      <span class="text-sm font-semibold text-gray-700 flex items-center justify-end gap-2">

                        TOTAL GENERAL
                      </span>
                    </div>
                     <div class="col-span-3 text-right">
                      
                     </div>
                    <div class="col-span-2 text-left">
                      <div class="flex flex-col items-end">
                        <span class="text-1xl font-bold text-purple-700 font-mono">
                       $ {{ $formatoMiles(totalPresupuestos( this.det.centros   )) }}
                        </span>
                       <span class="text-xs text-gray-400">
                          {{ centrosConPresupuesto }} centros con presupuesto
                        </span>
                      </div> 
                    </div>
                    <div class="col-span-2 text-left">
                      <div class="flex flex-col items-end">
                        <span class="text-1xl font-bold text-purple-700 font-mono">
                       $ {{ $formatoMiles(totalGastos( this.det.centros   )) }}
                        </span>
                      
                      </div> 
                    </div>
                    <div class=" text-center">
                      <span class="text-xs text-purple-600 font-medium">
                        {{ det.centros.length }} total
                      </span>
                    </div>
                  </div>

                </div>
              </div>

              <!-- Footer (fijo) -->
              <div class="px-6 py-3 bg-gray-50/80 border-t border-gray-100 flex-shrink-0">

                <div class="flex items-center justify-between">
                  <div class="flex items-center gap-4 text-xs text-gray-500">
                    <span>📊 {{ det.centros.length }} centros listados</span>
                    <span class="w-px h-4 bg-gray-300"></span>
                    <span>💰 {{ centrosConPresupuesto }} con presupuesto</span>
                    <span class="w-px h-4 bg-gray-300"></span>
                    <span>📭 {{ centrosSinPresupuesto }} sin presupuesto</span>
                  </div>
                  <div class="text-xs text-gray-400 flex items-center gap-1">
                    <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    {{ new Date().toLocaleString('es-CL') }}
                    <button @click="showModalDet = false"
                      class="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg text-sm transition-colors">
                      Cerrar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
      <div class="flex justify-end gap-2 mt-4">


      </div>
    </div>
  </div>
  

 <!-- MODAL DETALLE -->
  <div v-if="showModalDet2" class="fixed inset-0 z-50 flex items-center justify-center bg-black/70 ">
    
    <div class=" w-full max-w-5xl  p-6">
 
      <div class="w-full   mx-auto p-6">

        <div class="flex justify-between">

        <span class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">&lt;ReporteriaTablaTotales&gt;</span>
        <span class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">api/v1/presupuestos/centro/</span>
        
        </div>

        <div class=" overflow-hidden  ">


          <div class="w-full  mx-auto p-6">
            <div class="bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-100 h-[70vh] flex flex-col">

              <!-- Header (fijo) -->
              <div class="px-6 py-5 bg-gradient-to-r from-blue-800 via-pink-900 to-indigo-700 flex-shrink-0">
                <div class="flex items-center justify-between">
                  <div class="flex items-center gap-3">
                    <div class="p-2 bg-white/20 rounded-lg">
                      <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                      </svg>
                    </div>
                    <div>
                      
                      <p class="text-lg font-semibold uppercase text-white"> {{centro_nombre}} {{ titulo_modal }}</p>
                    </div>
                  </div>
                   
                </div>
              </div>

              <!-- Tabla con div (scrollable) -->
              <div class="flex-1 min-h-0 overflow-hidden ">
                <div class="h-full  overflow-y-auto overflow-x-auto">

                  <!-- Header -->
                  <div
                    class="sticky top-0 z-10 bg-gray-50/80 border-b border-gray-200 grid grid-cols-12 gap-2 px-6 py-3">
                    <div class="col-span-2 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">
                      #
                    </div> 
                    <div class="col-span-2 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">
                      Cuenta
                    </div>
                    <div class="col-span-2 text-right text-xs font-semibold text-gray-500 uppercase tracking-wider">
                      Presupuesto 
                    </div>
                    <div class="col-span-2 text-right text-xs font-semibold text-gray-500 uppercase tracking-wider">
                     Gastos
                    </div>
                      <div class="col-span-2 text-right text-xs font-semibold text-gray-500 uppercase tracking-wider">
                      Saldo  
                    </div>
                   
                  </div>

                 <!-- Body -->
                  <div class="divide-y divide-gray-100">
                    <div v-for="(centro, index) in  presupuestos" :key="centro.centro_id"
                      class="grid grid-cols-12 gap-2 px-6 py-3 hover:bg-purple-50/50 transition-colors duration-150 group items-center">
                      <div class="col-span-2 text-sm text-gray-400  ">
                        {{ String(index + 1).padStart(2, '0') }}
                      </div>
                      
                      <div class="col-span-2">
                        <span class="text-right  text-sm  ">
                          <b>{{ centro.nombre_cuenta }}</b>
                        </span>
                      </div>
                      <div class="col-span-2 text-right">

                        <span class="text-sm font-mono font-semibold"
                          :class="parseFloat(centro.total_presupuesto) > 0 ? 'text-gray-800' : 'text-gray-400'">
                          $ {{ $formatoMiles(centro.total_presupuesto) }}
                        </span>

                      </div>
                      <div class="col-span-2 text-right">

                        <span class="text-sm font-mono font-semibold"
                          :class="parseFloat(centro.total_gastos) > 0 ? 'text-gray-800' : 'text-gray-400'">
                          $ {{ $formatoMiles(centro.total_gastos) }}
                        </span>
                        <span @click="detalle_gastos(centro.cuenta_id)" v-if="centro.total_gastos > 0" style="cursor:pointer"> [+]</span>
                      </div>
                      <div class="col-span-2 text-right">

                        <span class="text-sm font-mono font-semibold"
                          :class="parseFloat(centro.total_saldo) > 0 ? 'text-gray-800' : 'text-red-400'">
                          $ {{ $formatoMiles(centro.total_saldo) }}
                        </span>
                       
                      </div>
                     
                    </div>
                  </div>
                  <!-- Total (sticky bottom) -->
                  <div
                    class="sticky bottom-0 z-10 bg-gradient-to-r from-purple-50/80 to-indigo-50/80 border-t-2 border-purple-200 grid grid-cols-12 gap-2 px-6 py-4">
                    <div class="col-span-3 text-right">
                      <span class="text-1xl text-sm font-semibold text-gray-700 flex items-center justify-end gap-2">

                        TOTAL  
                      </span>
                    </div>
                     <div class="col-span-1 text-right">
                      
                     </div>
                      <div class="col-span-2 text-left">
                      <div class="flex flex-col items-end">
                        <span class="text-1xl font-bold text-purple-700 font-mono">
                        $ {{ $formatoMiles(totalPresupuestos( this.presupuestos   )) }} 
                        </span>
                       <span class="text-xs text-gray-400">
                     
                        </span>
                      </div> 
                    </div>
                    <div class="col-span-2 text-left">
                      <div class="flex flex-col items-end">
                        <span class="text-1xl font-bold text-purple-700 font-mono">
                        $ {{ $formatoMiles(totalGastos( this.presupuestos  )) }}
                        </span>
                       <span class="text-xs text-gray-400">
                     
                        </span>
                      </div> 
                    </div>
                    <div class="col-span-2 text-left">
                      <div class="flex flex-col items-end">
                        <span class="text-1xl font-bold text-purple-700 font-mono">
                        $ {{ $formatoMiles( parseFloat( totalPresupuestos( this.presupuestos   )) -   parseFloat(totalGastos( this.presupuestos  )))  }} 
                        </span>
                      
                      </div> 
                    </div>
                    <div class=" text-center">
                      
                    </div>
                  </div>

                </div>
              </div>

              <!-- Footer (fijo) -->
              <div class="px-6 py-3 bg-gray-50/80 border-t border-gray-100 flex-shrink-0">

                <div class="flex items-center justify-end">
                   
                  <div class="text-xs text-gray-400 flex items-center gap-1">
                    
                    <button @click="showModalDet2 = false"
                      class="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg text-sm transition-colors">
                      Cerrar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
      <div class="flex justify-end gap-2 mt-4">


      </div>
    </div>
  </div>
  


</template>

 <script>

import api from "@/api/axios";
import { useCatPresup } from "@/composables/useCatPresup";
import { agrupa_categorias_suma_presupuestos2 } from "@/services/reporteria.services.js"
 
import ModalDetalleEjecucionPresupuestaria from "./ModalDetalleEjecucionPresupuestaria.vue";
import ModalLibroMayorDetalle from "@/components/libromayor/ModalLibroMayorDetalle.vue";

export default {
  name: 'ReporteriaTablaTotales',
  props: {
     borrador:{
      type:Boolean
    }  ,
    capitalInvestment:{
        type: Boolean,
        default: false
    }
  },
  computed: {
    presupIndex() {
      const mapa = {}
      const mapa2 = {}

      this.presup_ctas.forEach(p => {
        const key = `${p.centro_id}-${p.categoria_id}`
        mapa[key] = p.total_presupuesto

        if (p.total_presupuesto > 0) {
          mapa2[key] = p.total_gastos * 100 / p.total_presupuesto
        } else {
          if (p.total_gastos > 0) {
            mapa2[key] = "100"
          }
        }

      })

      return { presupuesto: mapa, ejecucion: mapa2 }
    },

    presupIndexCategorias() {
      const mapa = {}

      this.array_presupuesto_categorias.forEach(p => {
        const key = `${p.id}`
        mapa[key] = p.total_presupuesto
      })

      return mapa
    },
    totIndexCategorias() {
      let mapa = 0


      
      /**
       * [
{
   "id": 1,
   "nombre": "GASTOS DEL PERSONAL",
   "orden": 1,
   "total_gastos": 546997585,
   "total_presupuesto": 2332152398.2
},
{
   "id": 2,
   "nombre": "HONORARIOS",
   "orden": 2,
   "total_gastos": 88913071,
   "total_presupuesto": 529550760
} 
]
       */
      this.array_presupuesto_categorias.forEach(p => {
        mapa += p.total_presupuesto
      })


      return { total_presupuesto: mapa }
    },

    totPresupIndex() {
      const mapa = {}
      const mapa2 = {}

      // this.presup_ctas = [{ "categoria_id": 8, "centro_id": 29, "total_presupuesto": 6800000, "total_gastos": 0 },] 
      // reccorre y suma total  
      this.presup_ctas.forEach(p => {
        const key = `${p.centro_id}`
        if (mapa[key] == null) {
          mapa[key] = 0;
        }
        mapa[key] += p.total_presupuesto
      })


      return { presupuesto: mapa, ejecucion: mapa2 }
    },

    tot_tabla1() {
      return this.array_presupuesto_categorias.reduce(
        (acc, item) => {
          acc.presupuestos += Number(item.total_presupuesto || 0);
          acc.gastos += Number(item.total_gastos || 0);

          return acc;
        },
        { presupuestos: 0, gastos: 0 }
      );
    },

    mesesDisponibles() {
      const mesActual = new Date().getMonth() + 1
      return Array.from({ length: mesActual }, (_, i) => i + 1)
    },

    clasificacionesUsuario() {
      const usuario = this.clasificacion_unicos.find(
        item => item.user_id === this.selectedUserId
      );

      if (!usuario) return [];

      return usuario.clasificacioncentro_id.map(id => ({ id, nombre: this.nombreclasificacion[id] }));

    },
    centrosUsuarios() {
      if (!this.selectedClasificacionCentro) {
        return [];
      }
      const mapa = new Map();

      this.centros_responsables
        .filter(
          centro =>
            centro.clasificacioncentro_id === this.selectedClasificacionCentro &&
            centro.user.id === this.selectedUserId
        )
        .forEach(centro => {
          mapa.set(centro.id, {
            id: centro.id,
            nombre: centro.nombre
          });
        });

      return Array.from(mapa.values());
    },
    categoriasUsuario() {
      const categoriasUsuario = this.categorias.map(cat => ({
        id: cat.id,
        nombre: cat.nombre
      }))
      return categoriasUsuario
    },
    tiposCtaUsuario() {
      if (!this.selectedCategoria) {
        return [];
      }

      // método map() se usa en arreglos (arrays) y crea un nuevo arreglo aplicando una función a cada elemento del arreglo original. No modifica el arreglo original.
      const tipos = this.categorias
        .find(cat => cat.id === this.selectedCategoria)
        ?.tipos.map(tipo => ({
          id: tipo.id,
          nombre: tipo.nombre
        })) || [];
      return tipos;
    },

    cuentasUsuario() {
      let cuentas = [];

      if (this.selectedCategoria == 0 && this.selectedTipo == 0) {
        cuentas = this.categorias.flatMap(categoria =>
          categoria.tipos.flatMap(tipo =>
            tipo.cuentas.map(cuenta => ({
              id: cuenta.id,
              nombre: cuenta.nomcta,
              cod: cuenta.cod
            }))
          )
        );
      } else {
        if (this.selectedCategoria > 0 && this.selectedTipo == 0) {
          cuentas = this.categorias.find(cat => cat.id === this.selectedCategoria)
            ?.tipos.flatMap(tipo =>

              tipo.cuentas.map(cuenta => ({
                id: cuenta.id,
                nombre: cuenta.nomcta,
                cod: cuenta.cod
              }))
            ) || [];

        } else {
          if (this.selectedCategoria > 0 && this.selectedTipo > 0) {
            cuentas =
              this.categorias.find(cat => cat.id === this.selectedCategoria)
                ?.tipos.find(tipo => tipo.id === this.selectedTipo)
                ?.cuentas.map(cuenta => ({
                  id: cuenta.id,
                  nombre: cuenta.nomcta,
                  cod: cuenta.cod
                })) || [];

          }
        }
      }




      cuentas.sort((a, b) => a.nombre.localeCompare(b.nombre));

      return cuentas;

    },


    
    centrosConPresupuesto() {
      return this.det.centros.filter(c => parseFloat(c.total_presupuestos) > 0).length
    },
    centrosSinPresupuesto() {
      return this.det.centros.filter(c => parseFloat(c.total_presupuestos) === 0).length
    },
  
  },


  components: {
   
  
    ModalDetalleEjecucionPresupuestaria,
    ModalLibroMayorDetalle
  },
  mounted() {



    this.superUser = this.$store.state.auth.userLogin.modifica_presupuestos;
    this.user_id = this.$store.state.auth.userLogin.id;
    if (this.user_id == 6) {
      this.userEsCeciliaBrahm = true
    }
    this.inicializar()
    this.loadCentros()
    this.categoriasAgrupadas()
  },
  methods: {
    async detalle(centro_id, centro_nombre ){
        this.centro_id = centro_id
        this.centro_nombre = centro_nombre
        try {
                let data = {
                  "centro_id":  centro_id
                };
                if (this.categoria_id) {
                  data.categoria_id = this.categoria_id
                }
                if (this.borrador){
                  data["borrador"] = this.borrador
                }
                // solo trae presupuestos > 0
                const response = await api.post("api/v1/presupuestos/centro/", data, {
                  headers: {   "Content-Type": "application/json" }
                });
                if (response.status === 200) {
                  let p = response.data.presupuestos;
                
                  this.showModalDet2=true;


                  const cuentas = this.$store.state.cuentas.cuentas;
                  let cuentasCoincidentes;
                  // crea vector de cuentas en presupuestos
                  const cuentasIdSet = new Set(p.map((p) => p.cuenta_id));
                  // haz match
                  cuentasCoincidentes = cuentas.filter((c) => cuentasIdSet.has(c.id));
 
                  console.log('p',p)
                  this.presupuestos = p.map((item) => {
                      const cuenta = cuentasCoincidentes.find(
                        (c) => c.id === item.cuenta_id
                      );

                      return {
                        ...item,
                        nombre_cuenta: cuenta?.nombre || "",
                        total_presupuestos: item.total_presupuesto,
                        total_saldo:
                        (parseFloat(item.total_presupuesto) || 0) -
                        (parseFloat(item.total_gastos) || 0),
                      };
                  });

                 


                }
          } catch (e) {
            console.error("Credenciales inválidas ❌", e);
          }
   

    },
    async detalle_gastos(cuenta_id){
        try {

        const data = {
          cuenta_id: cuenta_id,
          centro_id: this.centro_id
        };
        if (this.borrador){
          data["borrador"] = this.borrador
        }
        const resp = await api.post(
          "/api/v1/presupuesto/gastos/",
          data,
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        );

        // ✅ petición exitosa
        this.listDetalle = resp.data.librosdetalles;
 

           this.showModalGasto=true;

      } catch (error) {
          console.log(error)
  
      }
   
    },
    inicializar(){
        this.aa_consulta =  this.$store.state.auth.userLogin.año  
        if (this.borrador)
        {
            this.aa_consulta = this.$store.state.auth.userLogin.año_borrador
        }
    },
    totalPresupuestos(centros) {
      
      return  centros.reduce((sum, centro) => {
        return sum + parseFloat(centro.total_presupuestos || 0)
      }, 0)
    },
   totalGastos(centros) {
       
      return  centros.reduce((sum, centro) => {
        return sum + parseFloat(centro.total_gastos || 0)
      }, 0)
    },
    nombreClasificacionCentro( clasificacioncentro_id ){
      const  c=JSON.parse(process.env.VUE_APP_CLASIF_CENTRO)
      return  c[clasificacioncentro_id] 
    },
    getCategoriaActual(categoriaId) {
      return this.array_presupuesto_categorias.find(
        actual => actual.id === categoriaId
      );
    },
    loadCentros() {
      
      const cc = this.$store.state.centros.centros
      // filtra solo C.C con RESPONSABLE asignado
      this.centros = cc.filter(c => c.usuarios && c.usuarios.length > 0);

      let autorizado = false
      if (this.superUser) {
        autorizado = true
      } else {
        if (this.userEsCeciliaBrahm) {
          autorizado = true;
        }
      }



      if (!autorizado) {
        /**
         *this.centros {
                "id": 60,
                "codigo": "PMA056000000000",
                "nombre": "Megatransecto",
                "tiene_presupuesto": true,
                "clasificacioncentro_id": 1,
                "user": {
                    "id": 11,
                    "first_name": "Mathias",
                    "last_name": "HÜNE"
                },
                "usuarios": [
                    {
                        "id": 11,
                        "first_name": "Mathias",
                        "last_name": "HÜNE"
                    },
                    {
                        "id": 6,
                        "first_name": "Cecilia",
                        "last_name": "Brahm"
                    },
                  
                    {
                        "id": 18,
                        "first_name": "OscaR",
                        "last_name": "Aguilera"
                    }
                ]
            }
         */
        this.centros.sort((a, b) => {
          const ua = a.clasificacioncentro_id ?? Infinity;
          const ub = b.clasificacioncentro_id ?? Infinity;
          return ua - ub;
        });


      } else {

        // solo para Super-Usuarios: listado de centros agrupado por usuario

        this.centros_responsables = []
        this.centros_responsables = cc.filter(c => c.user?.id > 0);

        this.centros_responsables.sort((a, b) => {
          const ua = a.user?.id ?? Infinity;
          const ub = b.user?.id ?? Infinity;
          return ua - ub;
        });



        // ordena por clasificacioncentro y orden
        this.centros.sort(
          (a, b) =>
            a.clasificacioncentro_id - b.clasificacioncentro_id ||
            a.orden - b.orden ||
            a.user.id - b.user.id
        )

      }


    },
    async categoriasAgrupadas() {


      let ctas;
      const allctas = this.$store.state.cuentas.cuentas
      if (this.capitalInvestment) {
        ctas = allctas.filter(
          cta => cta.tipo_cuenta?.categoria_cuenta?.id === parseInt(this.ID_CATEGORIA_INVERSIONES)
        );
      }else{
        ctas = allctas.filter(
          cta => cta.tipo_cuenta?.categoria_cuenta?.id !== parseInt(this.ID_CATEGORIA_INVERSIONES)
        );
      }



      // recupera cuentas con presupuestos ingresados
      this.loading = true;
      this.loading2 = true;
      this.loading_responsables = true;
      let presupuestos;
      try {
        let autorizado = false;
        let data = {}

        if (this.superUser) {
          autorizado = true
        } else {
          if (this.userEsCeciliaBrahm) {
            autorizado = true;
          }
        }


        if (!autorizado) {
          data = {
            user_id: this.user_id
          }
        }

        if(this.borrador){
          data['borrador']="True"
        }
        // trae presupuestos con o sin movimiento
        const response = await api.post("api/v1/presupuesto/todoscentros/", data, {
          headers: {
            "Content-Type": "application/json",

          },
        });

        if (response.status === 200) {
 
          this.año = response.data.año;
          presupuestos = response.data.presupuestos;
        
          const obj = agrupa_categorias_suma_presupuestos2(presupuestos, ctas)
          this.array_presupuesto_categorias_año_actual = obj.array_presupuesto_categorias
          this.array_detalle_centros_año_actual = obj.array_detalle_centros[0]

          console.log('array_detalle_centros', this.array_detalle_centros_año_actual )
  
          this.loading2 = false
 
          const { getCatPresupV2 } = useCatPresup()

          const { categorias  } = getCatPresupV2(presupuestos, ctas)
          this.categorias = categorias
          this.loading = false;
           

          

          // ordenar por atributo 'orden'
          this.categorias = Object.values(this.categorias).sort((a, b) =>
            (a.orden ?? Infinity) -
            (b.orden ?? Infinity)
          );
          this.array_presupuesto_categorias = this.categorias.map(grupo => ({
            id: grupo.id,
            nombre: grupo.nombre,
            orden: grupo.orden,
            total_gastos: grupo.tipos.flatMap(t => t.cuentas).reduce((acc, c) => acc + Number(c.total_gastos), 0),
            total_presupuesto: grupo.tipos.flatMap(t => t.cuentas).reduce((acc, c) => acc + Number(c.total_presupuesto), 0),

          }));

 
        }


      } catch (e) {
        console.error("Credenciales inválidas ❌", e);
      }




    },
    
   
   
    abreModal() {

      /**
       * 
        this.centros_responsables=[
        {
                "id": 63,
                "codigo": "VCO060000000000",
                "nombre": "Comunidades Magallanes",
                "tiene_presupuesto": true,
                "clasificacioncentro_id": 2,
                "presup_ctas":[
                {
                    "categoria_id":1,
                    "centro_id":63,
                    "total_presupuesto":0,
                    "total_gastos":77519
                },
                  
              ]

          },      
          {
              "id": 63,
                "codigo": "VCO060000000000",
                "nombre": "Comunidades Magallanes",
                "tiene_presupuesto": true,
                "clasificacioncentro_id": 2,
                "presup_ctas":[
                {
                    "categoria_id":1,
                    "centro_id":63,
                    "total_presupuesto":0,
                    "total_gastos":77519
                },
          }
        ]
       */
      if (this.selectedUserId > 0) {
        // filtra solo usuario seleccionado
        this.solo_centro_responsable_cuentas = this.responsables_y_cuentas.filter(responsable => responsable.user.id === this.selectedUserId)
      } else {
        this.solo_centro_responsable_cuentas = this.responsables_y_cuentas
      }



      // filtrar territorio: clasificacioncentro_id
      if (this.selectedClasificacionCentro > 0) {
        this.solo_centro_responsable_cuentas = this.solo_centro_responsable_cuentas.filter(centro => centro.clasificacioncentro_id == this.selectedClasificacionCentro)
      }
      // filtrar centro de costo: id
      if (this.selectedCentro > 0) {
        this.solo_centro_responsable_cuentas = this.solo_centro_responsable_cuentas.filter(centro => centro.id == this.selectedCentro)
      }
      if (this.selectedCategoria > 0) {
        this.solo_centro_responsable_cuentas =
          this.solo_centro_responsable_cuentas
            .map(centro => ({
              ...centro,
              presup_ctas: centro.presup_ctas.filter(
                p => p.categoria_id === this.selectedCategoria
              )
            }))
            .filter(centro => centro.presup_ctas.length > 0);
      }
      // filtrar tipo:  

      // filtrar cuenta
      if (this.selectedCuenta > 0) {
        // si seleccionaste cuenta, que solo se muestre la categoria relacionada.
        this.selectedCategoria = this.$store.state.cuentas.cuentas.find(
          cuenta => cuenta.id === this.selectedCuenta
        )?.tipo_cuenta?.categoria_cuenta?.id;

        this.solo_centro_responsable_cuentas =
          this.solo_centro_responsable_cuentas
            .map(centro => ({
              ...centro,
              presup_ctas: centro.presup_ctas.filter(
                p => p.categoria_id === this.selectedCategoria
              )
            }))
            .filter(centro => centro.presup_ctas.length > 0);

      }

      this.visibleModal = true
    },
    creaClasificacionesUnicas(responsables_y_cuentas) {

      const mapaUsuarios = new Map();

      responsables_y_cuentas.forEach(item => {

        let usuarios = [];

        // user puede ser objeto o array
        if (item.user) {
          usuarios = usuarios.concat(
            Array.isArray(item.user)
              ? item.user
              : [item.user]
          );
        }



        usuarios.forEach(usuario => {

          if (!mapaUsuarios.has(usuario.id)) {
            mapaUsuarios.set(usuario.id, {
              user_id: usuario.id,
              clasificacioncentro_id: []
            });
          }

          const registro = mapaUsuarios.get(usuario.id);

          if (
            !registro.clasificacioncentro_id.includes(
              item.clasificacioncentro_id
            )
          ) {
            registro.clasificacioncentro_id.push(
              item.clasificacioncentro_id
            );
          }
        });
      });

      const resultado = Array.from(mapaUsuarios.values());


      return resultado
    },
    openModalDet(categoria_id, nomcat) {
       
      this.det = this.array_detalle_centros_año_actual.find(det => det.categoria_id === categoria_id)
 
 
        
      const centros=this.$store.state.centros.centros
      const centro_y_prespuesto=this.det.centros


        // 1) Recorrer array 'centro_y_presupuesto'
      centro_y_prespuesto.forEach(item => {
            // 2) Buscar si el centro_id existe en el array centros
            const centroEncontrado = centros.find(centro => centro.id === item.centro_id);
            
            // 3) Si existe, extraer y agregar los campos al objeto
            if (centroEncontrado) {
                item.clasificacioncentro_id = centroEncontrado.clasificacioncentro_id;
                item.codigo = centroEncontrado.codigo;
                item.nombre = centroEncontrado.nombre;
            }
        });

        // 4) Ordenar objetos en centro_y_presupuesto
        // Primer criterio: clasificacioncentro_id (ascendente)
        // Segundo criterio: nombre (ascendente)
      centro_y_prespuesto.sort((a, b) => {
            // Primero ordenar por clasificacioncentro_id
            if (a.clasificacioncentro_id !== b.clasificacioncentro_id) {
                return a.clasificacioncentro_id - b.clasificacioncentro_id;
            }
            // Si son iguales, ordenar por nombre
            return a.nombre.localeCompare(b.nombre);
        });


      this.det.centros=centro_y_prespuesto
 

      this.titulo_modal = this.borrador ? `${nomcat} ${ this.$store.state.auth.userLogin.año_borrador}` :  `${nomcat} ${ this.$store.state.auth.userLogin.año}`
      this.categoria_id = categoria_id;
      this.showModalDet = true
    }
  },
  data() {
    return {
      ID_CATEGORIA_INVERSIONES : process.env.VUE_APP_ID_CATEGORIA_INVERSIONES,
      tipo_categoria: this.capitalInvestment ? "CAPITAL INVESTMENT 💼": 'OPERACIONAL 💵',
      array_detalle_centros_año_actual: [],
      colapsado1: true,
      colapsado2: true,
      colapsado3: true,
      colapsado4: true,
      centros: [],
      array_presupuesto_categorias: [],
      loading: false,
      loading2: false,
      presup_ctas: [],
      gastos_ctas: [],
      prop_obj_centro: false,
      prop_categoria_id: 0,
      solo_lectura: true,
      celda_seleccionada: '',
      categorias: {},
      categoriasCuentas: {},
      centro_id: 0,
      centro_nombre:'',
      categoria_id: 0,
      superUser: false,
      user_id: 0,
      objCentroSeleccionado: {},
      responsable_firstname: '',
      responsable_lastname: '',
      cuentaExpandida: [],
      colores: [

        "#dbfff7", // MARINE PROGRAM
        "#bfe5ff", // CAPE FROWARD NATIONAL PARK
        "#ffdbde", // CERRO CASTILLO NATIONAL PARK
        "#fcffe0", // PATAGONIA NATIONAL PARK
        "#aaffc8", // PUMALÍN DOUGLAS TOMPKINS NATIONAL PARK
        "#fff69e", //RUTA DE LOS PARQUES
        "#efc4fc", // GENERAL SUPPORT

      ],
      leyenda: [

        "Marine Program",
        "Cape Froward National Park",
        "Cerro Castillo National Park",
        "Patagonia National Park",
        "Pumalín Douglas Tompkins National Park",
        "Ruta de los Parques",
        "General Support"
      ],
      users_unicos: [],
      responsables_y_cuentas: [],
      solo_centro_responsable_cuentas: [],
      selectedUserId: 0,
      selectedMes: new Date().getMonth() + 1,
      loading_responsables: false,
      visibleModal: false,
      showModalGasto:false,
      año: '',
      nombreclasificacion: JSON.parse(process.env.VUE_APP_CLASIF_CENTRO),
      userEsCeciliaBrahm: false,
      selectedClasificacionCentro: 0,
      selectedCentro: 0,
      selectedCategoria: 0,
      selectedTipo: 0,
      selectedCuenta: 0,
      showModalDet: false,
      showModalDet2: false,      
      array_presupuesto_categorias_año_actual: [],
      aa_consulta:0,
      presupuestos:[],
      listDetalle:[],
   
    }


  }
}
</script>